/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AlertDto,
  AlertsControllerGetAlertsParams,
  DomainErrorDto,
  GetAlertsResponseDto
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const alertsControllerGetAlerts = (
    params?: AlertsControllerGetAlertsParams,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetAlertsResponseDto>(
      {url: `/api/v1/alerts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAlertsControllerGetAlertsQueryKey = (params?: AlertsControllerGetAlertsParams,) => {
    return [
    `/api/v1/alerts`, ...(params ? [params] : [])
    ] as const;
    }


export const getAlertsControllerGetAlertsQueryOptions = <TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(params?: AlertsControllerGetAlertsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlertsControllerGetAlertsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alertsControllerGetAlerts>>> = ({ signal }) => alertsControllerGetAlerts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlertsControllerGetAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof alertsControllerGetAlerts>>>
export type AlertsControllerGetAlertsQueryError = ErrorType<DomainErrorDto>


export function useAlertsControllerGetAlerts<TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  AlertsControllerGetAlertsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertsControllerGetAlerts>>,
          TError,
          Awaited<ReturnType<typeof alertsControllerGetAlerts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertsControllerGetAlerts<TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(
 params?: AlertsControllerGetAlertsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertsControllerGetAlerts>>,
          TError,
          Awaited<ReturnType<typeof alertsControllerGetAlerts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertsControllerGetAlerts<TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(
 params?: AlertsControllerGetAlertsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAlertsControllerGetAlerts<TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(
 params?: AlertsControllerGetAlertsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlertsControllerGetAlertsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getAlertsControllerGetAlertsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(params?: AlertsControllerGetAlertsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlertsControllerGetAlertsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alertsControllerGetAlerts>>> = ({ signal }) => alertsControllerGetAlerts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlertsControllerGetAlertsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof alertsControllerGetAlerts>>>
export type AlertsControllerGetAlertsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useAlertsControllerGetAlertsSuspense<TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  AlertsControllerGetAlertsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertsControllerGetAlertsSuspense<TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(
 params?: AlertsControllerGetAlertsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertsControllerGetAlertsSuspense<TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(
 params?: AlertsControllerGetAlertsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAlertsControllerGetAlertsSuspense<TData = Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError = ErrorType<DomainErrorDto>>(
 params?: AlertsControllerGetAlertsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlerts>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlertsControllerGetAlertsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const alertsControllerGetAlert = (
    id: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<AlertDto>(
      {url: `/api/v1/alerts/${id}`, method: 'GET', signal
    },
      options);
    }




export const getAlertsControllerGetAlertQueryKey = (id: string,) => {
    return [
    `/api/v1/alerts/${id}`
    ] as const;
    }


export const getAlertsControllerGetAlertQueryOptions = <TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlertsControllerGetAlertQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alertsControllerGetAlert>>> = ({ signal }) => alertsControllerGetAlert(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlertsControllerGetAlertQueryResult = NonNullable<Awaited<ReturnType<typeof alertsControllerGetAlert>>>
export type AlertsControllerGetAlertQueryError = ErrorType<DomainErrorDto>


export function useAlertsControllerGetAlert<TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertsControllerGetAlert>>,
          TError,
          Awaited<ReturnType<typeof alertsControllerGetAlert>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertsControllerGetAlert<TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertsControllerGetAlert>>,
          TError,
          Awaited<ReturnType<typeof alertsControllerGetAlert>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertsControllerGetAlert<TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAlertsControllerGetAlert<TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlertsControllerGetAlertQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getAlertsControllerGetAlertSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlertsControllerGetAlertQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alertsControllerGetAlert>>> = ({ signal }) => alertsControllerGetAlert(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlertsControllerGetAlertSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof alertsControllerGetAlert>>>
export type AlertsControllerGetAlertSuspenseQueryError = ErrorType<DomainErrorDto>


export function useAlertsControllerGetAlertSuspense<TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertsControllerGetAlertSuspense<TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertsControllerGetAlertSuspense<TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAlertsControllerGetAlertSuspense<TData = Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError = ErrorType<DomainErrorDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof alertsControllerGetAlert>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlertsControllerGetAlertSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const alertsControllerAcknowledge = (
    id: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<AlertDto>(
      {url: `/api/v1/alerts/${id}/acknowledge`, method: 'POST', signal
    },
      options);
    }



export const getAlertsControllerAcknowledgeMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertsControllerAcknowledge>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof alertsControllerAcknowledge>>, TError,{id: string}, TContext> => {

const mutationKey = ['alertsControllerAcknowledge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof alertsControllerAcknowledge>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  alertsControllerAcknowledge(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AlertsControllerAcknowledgeMutationResult = NonNullable<Awaited<ReturnType<typeof alertsControllerAcknowledge>>>

    export type AlertsControllerAcknowledgeMutationError = ErrorType<DomainErrorDto>

    export const useAlertsControllerAcknowledge = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertsControllerAcknowledge>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof alertsControllerAcknowledge>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAlertsControllerAcknowledgeMutationOptions(options), queryClient);
    }
    export const alertsControllerResolve = (
    id: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<AlertDto>(
      {url: `/api/v1/alerts/${id}/resolve`, method: 'POST', signal
    },
      options);
    }



export const getAlertsControllerResolveMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertsControllerResolve>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof alertsControllerResolve>>, TError,{id: string}, TContext> => {

const mutationKey = ['alertsControllerResolve'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof alertsControllerResolve>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  alertsControllerResolve(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AlertsControllerResolveMutationResult = NonNullable<Awaited<ReturnType<typeof alertsControllerResolve>>>

    export type AlertsControllerResolveMutationError = ErrorType<DomainErrorDto>

    export const useAlertsControllerResolve = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertsControllerResolve>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof alertsControllerResolve>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAlertsControllerResolveMutationOptions(options), queryClient);
    }
